const availableOptions = {
	styles: 'Styles',
	grid: 'Grid',
	vertical: 'Vertical layout',
	overlay: 'Overlay',
	slides: 'Slides',
	image: 'Image',
	text: 'Text',
	visualWithInfo: 'Visual with info',
	posters: 'Content',
	buttons: 'Buttons',
	link: 'Link block',
	popup: 'Popup',
	embed: 'Embed code',
}; 
export type LayoutOptions = keyof typeof availableOptions;

export function createOptionArray(keys:(keyof typeof availableOptions)[])
{
	const ret = {};
	for (const key of keys) 
		ret[key] = availableOptions[key];
	return ret;
}

/*
	Returns a list of all the possible option keys minus the excluded ones,
	with those in the 'ordered' list being placed first and in the order specified.

	NOTE this stuff kind-of interacts with the default option value...
*/
export function optionList(ordered: LayoutOptions[],exclude: LayoutOptions[])
{
	const all = new Set(Object.keys(availableOptions));
	let ret = [...ordered];

	for (const i of ordered)
		all.delete(i);
	for (const i of exclude)
		all.delete(i);

	for (const i of all)
		ret.push(i);
	return ret;
}

